import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { Input } from "@/components/ui/input"
import { TreatmentForm } from "@/modules/admin/treatment/schema/treatment-form-schema"
import { Language, LanguageValues } from "@/types/__generated__/union-types"

type SynonymsFieldName = "germanSynonyms" | "frenchSynonyms" | "italianSynonyms" | "englishSynonyms"

const SYNONYMS_FIELD_BY_LANGUAGE: Record<Language, SynonymsFieldName> = {
  GERMAN: "germanSynonyms",
  FRENCH: "frenchSynonyms",
  ITALIAN: "italianSynonyms",
  ENGLISH: "englishSynonyms",
}

const synonymsFields = LanguageValues.map((language) => ({
  language,
  fieldName: SYNONYMS_FIELD_BY_LANGUAGE[language],
}))

const TreatmentPlanTemplatesSectionSynonymsForm = () => {
  const { t } = useTranslation()

  const form = useFormContext<TreatmentForm>()

  const { register } = form

  return (
    <>
      <div className="text-on-surface-subdued col-span-4 text-sm font-medium">
        <label>{t("admin.treatment.form.synonyms")}</label>
      </div>
      {synonymsFields.map(({ language, fieldName }) => (
        <Input
          key={language}
          {...register(fieldName)}
          testId={`${language.toLowerCase()}-synonyms`}
          label={t(`admin.treatment.form.${language.toLowerCase()}`)}
          translateError
          errorClasses="truncate"
        />
      ))}
    </>
  )
}

export { TreatmentPlanTemplatesSectionSynonymsForm }
